import React, { useState, useEffect, useRef, useCallback } from 'react';
import './App.css';
import {
  IcRobot, IcChart, IcCode, IcCloud, IcGear, IcRefresh, IcTool,
  IcTrophy, IcMedal, IcStar, IcGrad, IcArrow, IcLinkedIn, IcGithub,
  IcMail, IcSun, IcMoon, IcExternalLink, IcCert, IcBrain,
  IcBook, IcWork, IcFlask
} from './icons';

// ── DATA ────────────────────────────────────────────────────────────────────

const CERTS = [
  { id:1, name:"Certificate Course on AI — Grade A+", issuer:"IBM SkillsBuild / ICT Academy", date:"2026", credId:"G-2026-G4969-0043", url:"https://skillsbuild.org", category:"AI", skills:["Machine Learning","Deep Learning","AI"] },
  { id:2, name:"CSR Program — IBM India Advanced IT Skills Phase III", issuer:"Edunet Foundation", date:"2026", credId:"S4F25_188185", url:"https://edunetfoundation.org", category:"AI", skills:["Advanced IT Skills","AI"] },
  { id:3, name:"Advanced Course on Green Skills and AI", issuer:"Edunet Foundation", date:"2025", credId:"S4F25_188185", url:"https://edunetfoundation.org", category:"AI", skills:["Green Skills","AI"] },
  { id:4, name:"AWS Academy Graduate — Data Engineering Badge", issuer:"Amazon Web Services (AWS)", date:"Nov 2025", credId:"", url:"https://aws.amazon.com/training/awsacademy/", category:"Cloud", skills:["Data Engineering","AWS"] },
  { id:5, name:"Artificial Intelligence Fundamentals", issuer:"IBM", date:"Nov 2025", credId:"", url:"https://www.ibm.com/training/", category:"AI", skills:["AI Fundamentals"] },
  { id:6, name:"AI-Enabled Applications for Customer Service", issuer:"IBM", date:"Nov 2025", credId:"", url:"https://www.ibm.com/training/", category:"AI", skills:["AI","Customer Service"] },
  { id:7, name:"Foundation Course on Green Skills and AI", issuer:"Edunet Foundation", date:"Mar 2025", credId:"54F25_137799", url:"https://edunetfoundation.org", category:"AI", skills:["Machine Learning","Deep Learning"] },
  { id:8, name:"Python Programming for Beginners", issuer:"Udemy", date:"Oct 2024", credId:"UC-41d3b2d7-b2e2-49dd-bf06-3c7297664ca9", url:"https://www.udemy.com/certificate/UC-41d3b2d7-b2e2-49dd-bf06-3c7297664ca9/", category:"Programming", skills:["Python"] },
  { id:9, name:"BCG — Data Science Job Simulation", issuer:"Forage", date:"Oct 2024", credId:"BWRyRt9cnyE8vFQmx", url:"https://www.theforage.com/", category:"Data", skills:["Data Science"] },
  { id:10, name:"JPMorgan Chase — Quantitative Research Simulation", issuer:"Forage", date:"Oct 2024", credId:"J8J7zb5fhKuQHMxGw", url:"https://www.theforage.com/", category:"Data", skills:["Quantitative Research"] },
  { id:11, name:"Accenture NA — Project Management Simulation", issuer:"Forage", date:"Sep 2024", credId:"CRejvR3MiutEGTGgL", url:"https://www.theforage.com/", category:"Business", skills:["Project Management"] },
  { id:12, name:"PwC Switzerland — Power BI Job Simulation", issuer:"Forage", date:"Sep 2024", credId:"qCYaoNTnReta6z3DM", url:"https://www.theforage.com/", category:"Data", skills:["Data Visualization","Power BI"] },
  { id:13, name:"Walmart USA — Advanced Software Engineering Simulation", issuer:"Forage", date:"Sep 2024", credId:"g364eNhTKco2zeKos", url:"https://www.theforage.com/", category:"Programming", skills:["Software Engineering"] },
  { id:14, name:"Accenture NA — Data Analytics & Visualization Simulation", issuer:"Forage", date:"Aug 2024", credId:"RLnuh8zpGJCvyR94N", url:"https://www.theforage.com/", category:"Data", skills:["Data Analysis","Data Visualization"] },
  { id:15, name:"Tata Group — Data Visualisation Job Simulation", issuer:"Forage", date:"Aug 2024", credId:"9wzZpqfLh5sbnsH7X", url:"https://www.theforage.com/", category:"Data", skills:["Data Analysis","Data Visualization"] },
  { id:16, name:"Google Data Analytics Capstone: Case Study", issuer:"Google", date:"Jul 2024", credId:"XTP3ZW95KXD8", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
  { id:17, name:"Data Analysis with R Programming", issuer:"Google", date:"Jun 2024", credId:"9ZW42FLAA7GD", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis","R"] },
  { id:18, name:"Share Data Through the Art of Visualization", issuer:"Google", date:"May 2024", credId:"H77FCC5CT8LQ", url:"https://www.coursera.org/", category:"Data", skills:["Visualization"] },
  { id:19, name:"Analyze Data to Answer Questions", issuer:"Google", date:"Mar 2024", credId:"Q5WEPNK7AYSB", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
  { id:20, name:"Process Data from Dirty to Clean", issuer:"Google", date:"Mar 2024", credId:"WG43LYA6YWTV", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
  { id:21, name:"Prepare Data for Exploration", issuer:"Google", date:"Mar 2024", credId:"2JXDSE734STY", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
  { id:22, name:"Ask Questions to Make Data-Driven Decisions", issuer:"Google", date:"Jan 2024", credId:"Q6KY8H4PPCNS", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
  { id:23, name:"Foundations: Data, Data, Everywhere", issuer:"Google", date:"Jan 2024", credId:"M9CZS2J6JF62", url:"https://www.coursera.org/", category:"Data", skills:["Data Analysis"] },
];

const RESEARCH = [
  { id:1, num:"01", title:"Sehat Sathi — AI-Powered Healthcare Application", venue:"4th International Conference on Trends in Herald in Engineering Excellence and Metamorphosis · TCOE, April 2025", url:"#", tags:["AI","Healthcare","NLP"] },
  { id:2, num:"02", title:"Glaucoma Detection using Deep Learning (VGG-16)", venue:"4th International Conference on Trends in Herald in Engineering Excellence and Metamorphosis · TCOE, April 2025", url:"#", tags:["Computer Vision","Deep Learning","VGG-16"] },
  { id:3, num:"03", title:"Fortifying Cyber Defense: Honeypot-Driven Strategies for DDoS Detection and Prevention", venue:"IJRASET · ISSN: 2321-9653 · Volume 14 Issue III · Mar 2026", url:"https://www.ijraset.com/best-journal/fortifying-cyber-defense-honeypot-driven-strategies-for-ddos-detection-and-prevention", tags:["Cybersecurity","DDoS","Honeypot","Network Security"] },
];

const AWARDS = [
  { badge:"Winner", Icon:IcTrophy, title:"Theem Hackathon 2024", org:"Theem College of Engineering", desc:"Won the prestigious hackathon showcasing innovation in AI-powered solutions." },
  { badge:"Runner-Up", Icon:IcTrophy, title:"Theem Hackathon 2023", org:"Theem College of Engineering", desc:"First runner-up at the annual innovation hackathon competition." },
  { badge:"Top 10", Icon:IcMedal, title:"ACE Hacks", org:"Atharva College of Engineering", desc:"Secured Top 10 position among all competing teams at the inter-college hackathon." },
  { badge:"Award", Icon:IcStar, title:"Mini Project Competition", org:"First Runner-Up", desc:"Certification of First Runner-Up in the Mini Project Presentation Competition." },
];

const PROJECTS = [
  { Icon:IcFlask, cat:"AI · Healthcare · Mobile", title:"Sehat Sathi", sub:"AI-Powered Healthcare Application", desc:"A cutting-edge AI-driven healthcare platform addressing challenges of delivering accurate and timely medical support in underserved areas. Integrates ML models, NLP chatbots, and Flutter mobile interface.", tech:["Flutter","Python","NLP","Deep Learning","Flask"], status:"Published Research", statusType:"published", accentColor:"var(--accent-blue)" },
  { Icon:IcChart, cat:"Data Analytics · Trading · Finance", title:"Market Sentiment", sub:"Behavior Analytics Assignment", desc:"Advanced sentiment-driven trading behavior analysis using Bitcoin Fear & Greed Index and Hyperliquid trader data. Statistical modeling, correlation heatmaps, and time-series analytics.", tech:["Python","Pandas","Matplotlib","Seaborn","Colab"], status:"Completed", statusType:"done", accentColor:"var(--accent-green)" },
  { Icon:IcBrain, cat:"AI · NLP · Research", title:"AstraMind", sub:"AI-Powered Research Assistant", desc:"An NLP-powered research assistant processing user queries using OpenAI models. Fetches relevant data from various fields including quantum computing with a scalable CLI architecture.", tech:["Python","OpenAI API","NLP","CLI","Modular Arch."], status:"Completed", statusType:"done", accentColor:"var(--accent-purple)" },
];

const SKILLS = [
  { cat:"AI & Machine Learning", Icon:IcRobot, filter:"ai", size:"lg", pills:["TensorFlow","Keras","PyTorch","scikit-learn","OpenCV","OpenAI API","NLTK","spaCy","Feature Eng.","Model Deploy"], hot:["TensorFlow","Keras","PyTorch","OpenAI API"] },
  { cat:"Data Science", Icon:IcChart, filter:"data", size:"sm", pills:["Pandas","NumPy","Matplotlib","Seaborn","Plotly","A/B Testing"], hot:["Pandas","NumPy"] },
  { cat:"Programming", Icon:IcCode, filter:"web", size:"sm", pills:["Python","R","SQL","JavaScript","PHP","Bash","HTML/CSS"], hot:["Python"] },
  { cat:"Frameworks", Icon:IcGear, filter:"web", size:"sm", pills:["Flask","RESTful API","JSON","BeautifulSoup","Selenium"], hot:["Flask"] },
  { cat:"Practices", Icon:IcRefresh, filter:"tools", size:"sm", pills:["Agile/Scrum","CI/CD","Data Cleaning","Storytelling","GDPR"], hot:[] },
  { cat:"Cloud & Databases", Icon:IcCloud, filter:"cloud", size:"lg", pills:["AWS EC2/S3","SageMaker","Render","Heroku","MySQL","MongoDB","PostgreSQL","SQLite","XAMPP","Docker"], hot:["AWS EC2/S3","MySQL"] },
  { cat:"Tools & Platforms", Icon:IcTool, filter:"tools", size:"sm", pills:["Jupyter","Google Colab","Tableau","Power BI","Anaconda","Postman","Excel","Git/GitHub"], hot:["Power BI"] },
];

// ── HOOKS ────────────────────────────────────────────────────────────────────

function useInView(threshold = 0.12) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold });
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, inView };
}

function useCounter(target: number, trigger: boolean, duration = 1600) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    const t0 = performance.now();
    const step = (now: number) => {
      const p = Math.min((now - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(eased * target));
      if (p < 1) requestAnimationFrame(step); else setVal(target);
    };
    requestAnimationFrame(step);
  }, [trigger, target, duration]);
  return val;
}

// ── LOADER ───────────────────────────────────────────────────────────────────

function Loader({ done }: { done: boolean }) {
  return (
    <div className={`loader${done ? ' done' : ''}`}>
      <div className="loader-content">
        <svg className="loader-logo-svg" width="56" height="56" viewBox="0 0 64 64" fill="none">
          <rect width="64" height="64" rx="14" fill="var(--gold)" fillOpacity="0.12"/>
          <text x="32" y="46" fontFamily="Georgia,serif" fontSize="40" fontWeight="700" fill="var(--gold)" textAnchor="middle">V</text>
          <rect x="10" y="54" width="44" height="2" rx="1" fill="var(--gold)" opacity="0.5"/>
        </svg>
        <div className="loader-name">VIVEKKUMAR</div>
        <div className="loader-bar-wrap"><div className="loader-bar" /></div>
        <div className="loader-sub">Loading portfolio...</div>
      </div>
    </div>
  );
}

// ── CURSOR ───────────────────────────────────────────────────────────────────

function Cursor() {
  const dotRef = useRef<HTMLDivElement>(null);
  const ringRef = useRef<HTMLDivElement>(null);
  const mx = useRef(0); const my = useRef(0);
  const rx = useRef(0); const ry = useRef(0);
  useEffect(() => {
    const onMove = (e: MouseEvent) => {
      mx.current = e.clientX; my.current = e.clientY;
      if (dotRef.current) dotRef.current.style.transform = `translate(${e.clientX - 4}px,${e.clientY - 4}px)`;
    };
    let raf: number;
    const animate = () => {
      rx.current += (mx.current - rx.current) * 0.11;
      ry.current += (my.current - ry.current) * 0.11;
      if (ringRef.current) ringRef.current.style.transform = `translate(${rx.current - 18}px,${ry.current - 18}px)`;
      raf = requestAnimationFrame(animate);
    };
    const expand = (e: Event) => { const t = e.target as Element; if (t.closest('a,button,.cert-card,.project-card,.award-card,.pill-tag,.research-item,.skills-tab')) ringRef.current?.classList.add('expanded'); };
    const shrink = () => ringRef.current?.classList.remove('expanded');
    document.addEventListener('mousemove', onMove);
    raf = requestAnimationFrame(animate);
    document.addEventListener('mouseover', expand);
    document.addEventListener('mouseout', shrink);
    return () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseover', expand); document.removeEventListener('mouseout', shrink); cancelAnimationFrame(raf); };
  }, []);
  return (<><div className="cur-dot" ref={dotRef} /><div className="cur-ring" ref={ringRef} /></>);
}

// ── NAVBAR ───────────────────────────────────────────────────────────────────

function Navbar({ theme, toggleTheme }: { theme: string; toggleTheme: () => void }) {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('home');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => {
      setScrolled(window.scrollY > 50);
      const ids = ['home','about','skills','experience','projects','achievements','research','certifications','contact'];
      for (let i = ids.length - 1; i >= 0; i--) { const el = document.getElementById(ids[i]); if (el && window.scrollY >= el.offsetTop - 160) { setActive(ids[i]); break; } }
    };
    window.addEventListener('scroll', fn, { passive: true }); return () => window.removeEventListener('scroll', fn);
  }, []);

  const go = (id: string) => {
    const el = document.getElementById(id); if (!el) return;
    const nav = document.querySelector('.navbar') as HTMLElement;
    window.scrollTo({ top: el.offsetTop - (nav?.offsetHeight || 70) - 12, behavior: 'smooth' });
    setOpen(false);
  };

  const links = ['home','about','skills','experience','projects','achievements','research','certifications','contact'];
  const labels: Record<string,string> = { home:'Home', about:'About', skills:'Skills', experience:'Experience', projects:'Projects', achievements:'Awards', research:'Research', certifications:'Certs', contact:'Contact' };

  return (
    <>
      <header className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <button className="nav-logo" onClick={() => go('home')}>
          <svg width="28" height="28" viewBox="0 0 64 64" fill="none" className="nav-logo-mark">
            <rect width="64" height="64" rx="12" fill="var(--gold)" fillOpacity="0.15"/>
            <text x="32" y="46" fontFamily="Georgia,serif" fontSize="38" fontWeight="700" fill="var(--gold)" textAnchor="middle">V</text>
          </svg>
          <span><span className="logo-v">VIVEK</span><span className="logo-k">KUMAR</span></span>
        </button>
        <nav className="nav-links">
          {links.map(l => <button key={l} className={`nav-link${active === l ? ' active' : ''}`} onClick={() => go(l)}>{labels[l]}</button>)}
        </nav>
        <div className="nav-actions">
          <button className="theme-btn" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? <IcSun size={16} /> : <IcMoon size={16} />}
          </button>
          <a href="mailto:vivekchauhan2385@gmail.com" className="hire-btn">Hire Me</a>
          <button className={`hamburger${open ? ' open' : ''}`} onClick={() => setOpen(!open)} aria-label="Menu"><span /><span /><span /></button>
        </div>
      </header>
      {open && (
        <div className="mob-overlay" onClick={() => setOpen(false)}>
          <div className="mob-panel" onClick={e => e.stopPropagation()}>
            <button className="mob-close" onClick={() => setOpen(false)}>✕</button>
            {links.map(l => <button key={l} className="mob-link" onClick={() => go(l)}>{labels[l]}</button>)}
            <a href="mailto:vivekchauhan2385@gmail.com" className="hire-btn mob-hire">Hire Me</a>
          </div>
        </div>
      )}
    </>
  );
}

// ── HERO ─────────────────────────────────────────────────────────────────────

function StatCounter({ target, suffix = '', trigger }: { target: number; suffix?: string; trigger: boolean }) {
  const val = useCounter(target, trigger);
  return <><span className="sn">{val}</span><span className="ss">{suffix}</span></>;
}

function Hero() {
  const { ref, inView } = useInView(0.1);
  return (
    <section id="home" className="hero">
      <div className="hero-grid" />
      <div className="orb orb1" /><div className="orb orb2" /><div className="orb orb3" />
      <div className="hero-wrap" ref={ref}>
        <div className={`hero-left fade-left${inView ? ' in' : ''}`}>
          <div className="avail-badge"><span className="avail-dot" />Available for Opportunities</div>
          <h1 className="hero-h1">
            <span className="h1-hello">Hello, I'm</span>
            <span className="h1-name"><em className="gold">Vivek</em>kumar</span>
            <span className="h1-last">Chauhan</span>
          </h1>
          <p className="hero-role"><span className="br">[</span> AI &amp; Data Science Developer <span className="br">]</span></p>
          <p className="hero-desc">Computer Engineering student building intelligent systems, automation pipelines and cloud-based solutions — from AI-driven healthcare to cybersecurity and market analytics.</p>
          <div className="hero-btns">
            <button className="btn-p" onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>Explore Work <IcArrow size={16} /></button>
            <button className="btn-g" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Get In Touch</button>
          </div>
          <div className="hero-links">
            <a href="https://linkedin.com/in/vivek92" target="_blank" rel="noopener noreferrer" className="h-link"><IcLinkedIn size={15} />LinkedIn</a>
            <a href="https://github.com/VivekkumarChauhan" target="_blank" rel="noopener noreferrer" className="h-link"><IcGithub size={15} />GitHub</a>
            <a href="mailto:vivekchauhan2385@gmail.com" className="h-link"><IcMail size={15} />Email</a>
          </div>
        </div>
        <div className={`hero-right fade-right${inView ? ' in' : ''}`}>
          <div className="float-pill pill-top"><IcTrophy size={14} />Hackathon Winner 2024</div>
          <div className="stats-card">
            <div className="sc-head"><span className="sc-label">QUICK STATS</span><span className="sc-live" /></div>
            <div className="sc-grid">
              <div className="sc-item"><div className="sc-num"><StatCounter target={3} suffix="+" trigger={inView} /></div><div className="sc-lbl">AI Projects</div></div>
              <div className="sc-item"><div className="sc-num"><StatCounter target={3} trigger={inView} /></div><div className="sc-lbl">Research Papers</div></div>
              <div className="sc-item"><div className="sc-num"><StatCounter target={23} suffix="+" trigger={inView} /></div><div className="sc-lbl">Certifications</div></div>
              <div className="sc-item"><div className="sc-num"><StatCounter target={3} suffix="x" trigger={inView} /></div><div className="sc-lbl">Hackathon Wins</div></div>
            </div>
            <div className="sc-chips">{["Machine Learning","Deep Learning","NLP","AWS Cloud","Automation"].map(c => <span key={c} className="sc-chip">{c}</span>)}</div>
          </div>
          <div className="float-pill pill-bot"><IcBook size={14} />3 Published Papers</div>
        </div>
      </div>
      <div className="scroll-ind"><span>scroll</span><div className="scroll-bar" /></div>
    </section>
  );
}

// ── MARQUEE ───────────────────────────────────────────────────────────────────

function Marquee() {
  const items = ["Machine Learning","Deep Learning","NLP","Data Science","AI Development","Cloud Computing","Python","TensorFlow","Computer Vision","Automation","Cybersecurity","DDoS Defense","OpenAI API","Data Analytics"];
  const doubled = [...items, ...items];
  return (
    <div className="marquee-wrap">
      <div className="marquee-track">{doubled.map((it, i) => <span key={i} className="m-it">{it}<span className="m-dot">·</span></span>)}</div>
    </div>
  );
}

// ── SECTION HEADER ────────────────────────────────────────────────────────────

function SH({ num, pre, post }: { num: string; pre: string; post: string }) {
  const { ref, inView } = useInView();
  return (
    <div className={`sh${inView ? ' in' : ''}`} ref={ref}>
      <span className="sh-num">{num}</span>
      <h2 className="sh-title">{pre} <span className="sh-outline">{post}</span></h2>
      <div className="sh-line" />
    </div>
  );
}

// ── ABOUT ─────────────────────────────────────────────────────────────────────

function About() {
  const { ref, inView } = useInView();
  return (
    <section id="about" className="section">
      <div className="ctr">
        <SH num="01 — About Me" pre="The Mind" post="Behind the Machine" />
        <div className="about-grid" ref={ref}>
          <div className={`about-vis fade-left${inView ? ' in' : ''}`}>
            <div className="about-frame">
              <div className="about-img-box">
                <img src="./assets/img.jpeg" alt="Vivekkumar Chauhan" onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
                <div className="about-initials">V</div>
              </div>
              <div className="about-deco-ring" />
              <div className="about-deco-dot d1" /><div className="about-deco-dot d2" />
            </div>
            <div className="about-badges">
              {[{I:IcRobot,t:"AI / ML Expert"},{I:IcChart,t:"Data Scientist"},{I:IcFlask,t:"Researcher"}].map(m => (
                <div key={m.t} className="about-badge"><m.I size={16} /><span>{m.t}</span></div>
              ))}
            </div>
          </div>
          <div className={`about-body fade-right${inView ? ' in' : ''}`}>
            <h3 className="about-sub">AI Developer &amp; Data Science Enthusiast</h3>
            <p>I'm a Computer Engineering student with a minor in <strong>Data Science</strong> at Theem College of Engineering, driven by a passion for building intelligent systems that solve real-world problems.</p>
            <p>Currently working as an <strong className="gold">AI &amp; Automation Developer</strong> at Optimus Nexgen Wealth Private Limited, engineering automated data pipelines and AI-powered workflows at scale.</p>
            <p>My work spans AI-driven healthcare, computer vision, cybersecurity research, and market sentiment analysis — always pushing what intelligent systems can achieve.</p>
            <div className="about-tags">
              {["AI/ML Engineering","Data Analytics","NLP & CV","Cloud Deployment","Research","Automation","Cybersecurity"].map(t => <span key={t} className="atag">{t}</span>)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── SKILLS ────────────────────────────────────────────────────────────────────

function SkBlock({ s, i }: { s: typeof SKILLS[0]; i: number }) {
  const { ref, inView } = useInView();
  return (
    <div className={`sk-block${s.size === 'lg' ? ' sk-lg' : ''}`} ref={ref}
      style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(28px)', transition: `opacity 0.55s ease ${i * 0.07}s, transform 0.55s ease ${i * 0.07}s` }}>
      <div className="sk-head"><s.Icon size={20} className="sk-icon" /><h4 className="sk-cat">{s.cat}</h4></div>
      <div className="sk-pills">{s.pills.map(p => <span key={p} className={`ptag${s.hot.includes(p) ? ' hot' : ''}`}>{p}</span>)}</div>
      <div className="sk-glow" />
    </div>
  );
}

function Skills() {
  const [filter, setFilter] = useState('all');
  const tabs = ['all','ai','data','web','cloud','tools'];
  const tl: Record<string, string> = { all:'All', ai:'AI / ML', data:'Data Science', web:'Web & Dev', cloud:'Cloud & DB', tools:'Tools' };
  return (
    <section id="skills" className="section s-alt">
      <div className="ctr">
        <SH num="02 — Technical Arsenal" pre="Skills &" post="Technologies" />
        <div className="sk-tabs">{tabs.map(t => <button key={t} className={`sk-tab${filter === t ? ' active' : ''}`} onClick={() => setFilter(t)}>{tl[t]}</button>)}</div>
        <div className="sk-bento">{SKILLS.filter(s => filter === 'all' || s.filter === filter).map((s, i) => <SkBlock key={s.cat} s={s} i={i} />)}</div>
      </div>
    </section>
  );
}

// ── EXPERIENCE ────────────────────────────────────────────────────────────────

function Experience() {
  const { ref, inView } = useInView();
  return (
    <section id="experience" className="section">
      <div className="ctr">
        <SH num="03 — Experience" pre="My Professional" post="Journey" />
        <div className="tl" ref={ref}>
          <div className={`tl-item${inView ? ' in' : ''}`}>
            <div className="tl-marker"><div className="tl-dot" /><div className="tl-vline" /></div>
            <div className="tl-body">
              <div className="tl-date">May 2025 — Present</div>
              <div className="tl-card">
                <div className="tl-top">
                  <div><h3 className="tl-role">AI &amp; Automation Developer</h3><div className="tl-co">Optimus Nexgen Wealth Pvt. Ltd. · Ghatkopar, Mumbai</div></div>
                  <span className="tl-badge">Internship</span>
                </div>
                <p className="tl-desc">Engineered automated data integration pipelines processing and updating real-time data across internal systems. Developed an AI-assisted PDF generation workflow creating single daily reports that dynamically reflect all data changes — ensuring accurate, up-to-date insights.</p>
                <div className="tl-pills">{["Python","AI Automation","PDF Generation","Data Pipelines"].map(t => <span key={t} className="tl-pill">{t}</span>)}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── PROJECTS ──────────────────────────────────────────────────────────────────

function PCard({ p, i }: { p: typeof PROJECTS[0]; i: number }) {
  const { ref, inView } = useInView();
  return (
    <div className="p-card" ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(36px)', transition: `opacity 0.6s ease ${i * 0.14}s, transform 0.6s ease ${i * 0.14}s` }}>
      <div className="p-thumb" style={{ '--acc': p.accentColor } as React.CSSProperties}>
        <div className="p-thumb-bg" />
        <p.Icon size={48} className="p-ico" />
      </div>
      <div className="p-body">
        <div className="p-cat">{p.cat}</div>
        <h3 className="p-title">{p.title}</h3>
        <p className="p-sub">{p.sub}</p>
        <p className="p-desc">{p.desc}</p>
        <div className="p-tech">{p.tech.map(t => <span key={t} className="p-tag">{t}</span>)}</div>
        <div className="p-foot"><span className={`p-status s-${p.statusType}`}>{p.status}</span></div>
      </div>
    </div>
  );
}

function Projects() {
  return (
    <section id="projects" className="section s-alt">
      <div className="ctr">
        <SH num="04 — Projects" pre="Featured" post="Work" />
        <div className="p-grid">{PROJECTS.map((p, i) => <PCard key={p.title} p={p} i={i} />)}</div>
      </div>
    </section>
  );
}

// ── ACHIEVEMENTS ──────────────────────────────────────────────────────────────

function ACard({ a, i }: { a: typeof AWARDS[0]; i: number }) {
  const { ref, inView } = useInView();
  return (
    <div className="a-card" ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(28px)', transition: `opacity 0.5s ease ${i * 0.1}s, transform 0.5s ease ${i * 0.1}s` }}>
      <div className="a-badge">{a.badge}</div>
      <div className="a-icon-wrap"><a.Icon size={28} className="a-icon" /></div>
      <h3 className="a-title">{a.title}</h3>
      <p className="a-org">{a.org}</p>
      <p className="a-desc">{a.desc}</p>
    </div>
  );
}

function Achievements() {
  return (
    <section id="achievements" className="section">
      <div className="ctr">
        <SH num="05 — Achievements" pre="Honours &" post="Recognition" />
        <div className="a-grid">{AWARDS.map((a, i) => <ACard key={a.title} a={a} i={i} />)}</div>
      </div>
    </section>
  );
}

// ── EDUCATION ─────────────────────────────────────────────────────────────────

function Education() {
  const { ref, inView } = useInView();
  return (
    <section id="education" className="section s-alt">
      <div className="ctr">
        <SH num="06 — Education" pre="Academic" post="Foundation" />
        <div className="edu-wrap" ref={ref}>
          <div className={`edu-card${inView ? ' in' : ''}`}>
            <div className="edu-icon-wrap"><IcGrad size={36} className="edu-icon" /></div>
            <h3 className="edu-deg">Bachelor of Engineering</h3>
            <p className="edu-major">Computer Engineering (Minor: Data Science)</p>
            <p className="edu-school">Theem College of Engineering</p>
            <p className="edu-dates">2022 — Present</p>
            <span className="edu-pill">In Progress</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── RESEARCH ──────────────────────────────────────────────────────────────────

function RItem({ r, i }: { r: typeof RESEARCH[0]; i: number }) {
  const ref = useRef<HTMLAnchorElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold: 0.1 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return (
    <a href={r.url} target="_blank" rel="noopener noreferrer" className="r-item" ref={ref}
      style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateX(-24px)', transition: `opacity 0.55s ease ${i * 0.14}s, transform 0.55s ease ${i * 0.14}s` }}>
      <div className="r-num">{r.num}</div>
      <div className="r-body">
        <h3 className="r-title">{r.title}</h3>
        <p className="r-venue">{r.venue}</p>
        <div className="r-tags">{r.tags.map(t => <span key={t} className="r-tag">{t}</span>)}</div>
      </div>
      <div className="r-arr"><IcExternalLink size={16} /></div>
    </a>
  );
}

function Research() {
  return (
    <section id="research" className="section">
      <div className="ctr">
        <SH num="07 — Research" pre="Published" post="Papers" />
        <div className="r-list">{RESEARCH.map((r, i) => <RItem key={r.id} r={r} i={i} />)}</div>
      </div>
    </section>
  );
}

// ── CERTIFICATIONS ────────────────────────────────────────────────────────────

function CertPopup({ cert, onClose }: { cert: typeof CERTS[0]; onClose: () => void }) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', esc);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', esc); document.body.style.overflow = ''; };
  }, [onClose]);
  return (
    <div className="pop-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="pop-box" onClick={e => e.stopPropagation()}>
        <button className="pop-close" onClick={onClose} aria-label="Close">✕</button>
        <div className="pop-icon-wrap"><IcCert size={32} className="pop-icon-svg" /></div>
        <h3 className="pop-name">{cert.name}</h3>
        <p className="pop-issuer">{cert.issuer}</p>
        <p className="pop-date">{cert.date}</p>
        {cert.credId && <p className="pop-cred">Credential ID: <code>{cert.credId}</code></p>}
        <div className="pop-skills">{cert.skills.map(s => <span key={s} className="ptag">{s}</span>)}</div>
        <a href={cert.url} target="_blank" rel="noopener noreferrer" className="btn-p pop-btn">View Credential <IcExternalLink size={14} /></a>
      </div>
    </div>
  );
}

function CCard({ c, i, onClick }: { c: typeof CERTS[0]; i: number; onClick: () => void }) {
  const { ref, inView } = useInView();
  return (
    <div className="c-card" ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? 'none' : 'translateY(18px)', transition: `opacity 0.4s ease ${(i % 4) * 0.06}s, transform 0.4s ease ${(i % 4) * 0.06}s` }}
      onClick={onClick} role="button" tabIndex={0} onKeyDown={e => { if (e.key === 'Enter') onClick(); }}>
      <div className="c-icon-wrap"><IcCert size={22} className="c-icon" /></div>
      <div className="c-info">
        <p className="c-name">{c.name}</p>
        <p className="c-by">{c.issuer}</p>
        <p className="c-date">{c.date}</p>
        {c.credId && <p className="c-id">{c.credId.slice(0, 26)}{c.credId.length > 26 ? '…' : ''}</p>}
      </div>
      <div className="c-hint"><IcExternalLink size={14} /></div>
    </div>
  );
}

function Certifications() {
  const [popup, setPopup] = useState<typeof CERTS[0] | null>(null);
  const [filter, setFilter] = useState('All');
  const cats = ['All', ...Array.from(new Set(CERTS.map(c => c.category)))];
  const filtered = filter === 'All' ? CERTS : CERTS.filter(c => c.category === filter);
  return (
    <section id="certifications" className="section s-alt">
      <div className="ctr">
        <SH num="08 — Certifications" pre="Credentials &" post="Courses" />
        <div className="c-tabs">{cats.map(c => <button key={c} className={`sk-tab${filter === c ? ' active' : ''}`} onClick={() => setFilter(c)}>{c}</button>)}</div>
        <div className="c-grid">{filtered.map((c, i) => <CCard key={c.id} c={c} i={i} onClick={() => setPopup(c)} />)}</div>
      </div>
      {popup && <CertPopup cert={popup} onClose={() => setPopup(null)} />}
    </section>
  );
}

// ── CONTACT ───────────────────────────────────────────────────────────────────

function Contact() {
  const { ref, inView } = useInView();
  return (
    <section id="contact" className="section">
      <div className="ctr">
        <SH num="09 — Contact" pre="Let's" post="Connect" />
        <div className="ct-grid" ref={ref}>
          <div className={`ct-info fade-left${inView ? ' in' : ''}`}>
            <h3 className="ct-head">Open to Opportunities</h3>
            <p className="ct-sub">Whether you're looking to collaborate on AI projects, need a skilled developer, or want to discuss research — I'd love to hear from you.</p>
            <div className="ct-items">
              <a href="mailto:vivekchauhan2385@gmail.com" className="ct-item"><span className="ct-ic"><IcMail size={17} /></span><div><span className="ct-lbl">Email</span><span className="ct-val">vivekchauhan2385@gmail.com</span></div></a>
              <a href="https://linkedin.com/in/vivek92" target="_blank" rel="noopener noreferrer" className="ct-item"><span className="ct-ic"><IcLinkedIn size={17} /></span><div><span className="ct-lbl">LinkedIn</span><span className="ct-val">linkedin.com/in/vivek92</span></div></a>
              <a href="https://github.com/VivekkumarChauhan" target="_blank" rel="noopener noreferrer" className="ct-item"><span className="ct-ic"><IcGithub size={17} /></span><div><span className="ct-lbl">GitHub</span><span className="ct-val">VivekkumarChauhan</span></div></a>
            </div>
          </div>
          <div className={`ct-cta fade-right${inView ? ' in' : ''}`}>
            <div className="ct-cta-box">
              <div className="ct-cta-icon"><IcWork size={32} /></div>
              <h3>Ready to Work Together?</h3>
              <p>Available for internships, freelance projects, and research collaborations in AI &amp; Data Science.</p>
              <div className="ct-btns">
                <a href="mailto:vivekchauhan2385@gmail.com" className="btn-p">Send Email <IcArrow size={15} /></a>
                <a href="https://linkedin.com/in/vivek92" target="_blank" rel="noopener noreferrer" className="btn-g">LinkedIn Profile</a>
              </div>
              <div className="ct-or">or reach me on</div>
              <div className="ct-pills">
                <a href="https://github.com/VivekkumarChauhan" target="_blank" rel="noopener noreferrer" className="h-link"><IcGithub size={14} />GitHub</a>
                <a href="https://linkedin.com/in/vivek92" target="_blank" rel="noopener noreferrer" className="h-link"><IcLinkedIn size={14} />LinkedIn</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ── FOOTER ────────────────────────────────────────────────────────────────────

function Footer() {
  return (
    <footer className="footer">
      <div className="ctr foot-inner">
        <button className="nav-logo foot-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <svg width="22" height="22" viewBox="0 0 64 64" fill="none">
            <rect width="64" height="64" rx="12" fill="var(--gold)" fillOpacity="0.15"/>
            <text x="32" y="46" fontFamily="Georgia,serif" fontSize="38" fontWeight="700" fill="var(--gold)" textAnchor="middle">V</text>
          </svg>
          <span><span className="logo-v">VIVEK</span><span className="logo-k">KUMAR</span></span>
        </button>
        <p className="foot-txt">© 2026 Vivekkumar Chauhan · AI &amp; Data Science Developer</p>
        <div className="foot-links">
          <a href="https://linkedin.com/in/vivek92" target="_blank" rel="noopener noreferrer" className="foot-link" aria-label="LinkedIn"><IcLinkedIn size={16} /></a>
          <a href="https://github.com/VivekkumarChauhan" target="_blank" rel="noopener noreferrer" className="foot-link" aria-label="GitHub"><IcGithub size={16} /></a>
          <a href="mailto:vivekchauhan2385@gmail.com" className="foot-link" aria-label="Email"><IcMail size={16} /></a>
        </div>
      </div>
    </footer>
  );
}

// ── APP ───────────────────────────────────────────────────────────────────────

export default function App() {
  const [theme, setTheme] = useState<string>(() => localStorage.getItem('vk-theme') || 'dark');
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { document.documentElement.setAttribute('data-theme', theme); localStorage.setItem('vk-theme', theme); }, [theme]);
  useEffect(() => { const t = setTimeout(() => setLoaded(true), 1700); return () => clearTimeout(t); }, []);
  const toggleTheme = useCallback(() => setTheme(t => t === 'dark' ? 'light' : 'dark'), []);
  return (
    <>
      <Loader done={loaded} />
      <Cursor />
      <Navbar theme={theme} toggleTheme={toggleTheme} />
      <main>
        <Hero /><Marquee /><About /><Skills /><Experience /><Projects /><Achievements /><Education /><Research /><Certifications /><Contact />
      </main>
      <Footer />
    </>
  );
}
